<template>
  <div class="row-grid block__mod" :class="{'left':position,'mobile_b':mobile}">
      <div class="col-md-6 item img-item" v-if="!mobile">
        <nuxt-link v-if="!linkRef && link !== '#'" :to="link" class="content">
           <div class="img" v-if="img" :style="'background-image: url('+ img +');'"></div>
           <div class="img" v-else></div>
        </nuxt-link>
        <a v-if="linkRef" :href="linkRef" class="content">
          <div class="img" v-if="img" :style="'background-image: url('+ img +');'"></div>
          <div class="img" v-else></div>
        </a>
        <div v-if="link === '#'" :to="link" class="content">
          <div class="img" v-if="img" :style="'background-image: url('+ img +');'"></div>
          <div class="img" v-else></div>
        </div>
      </div>
      <div class="col-md-6 item">
        <div class="content">
          <div class="title" v-html="title"></div>
          <div class="description">
             <slot></slot>
          </div>
          <div class="buttons" v-if="buttonShow">
            <nuxt-link :to="link" v-if="!linkRef" class="btn solid--green large">{{buttonText}}</nuxt-link>
            <a :href="linkRef" v-if="linkRef" target="_blank" class="btn solid--green large">{{buttonText}}</a>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
    export default {
        name: "CardBox",
        props: {
          img: { type: String ,default: null},
          title: { type: String },
          link: { type: String, default: '#'},
          linkRef: { type: String},
          buttonText: { type: String, default: 'Подробнее' },
          buttonShow: { type: Boolean, default: true },
          position: { type: Boolean, default: false},
          mobile: { type: Boolean, default: false},
        },
    }
</script>

<style lang="scss" scoped>
   .block__mod {
      .img {
         background-repeat: no-repeat;
         background-size: cover;
         transition: all 1s ease;
         -webkit-filter: grayscale(100%);
         &:hover {
           -webkit-filter: grayscale(0%);
         }
      }
      .title {
        @include font-size(47px,normal);
        font-weight: bold;
        @media (max-width: $media_book) {
            font-size: 37px;
        }
        @media (max-width: $media_sm) {
            font-size: 25px;
        }
      }
      &.mobile_b {

      }
   }
</style>



// WEBPACK FOOTER //
// components/shared/cards/CardBox.vue